import { useContext } from "react";
import { DrawerContext } from "../../../shared/contexts/drawer.context";

export function useDrawer() {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawer must be used inside DrawerProvider");
  }
  return context;
}
